
      var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWifiIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.91 37.436C20.272 27.808 33.43 21.818 48 21.818c14.57 0 27.727 5.99 37.091 15.618M26.526 55.005c5.104-5.961 12.829-9.76 21.474-9.76s16.37 3.799 21.474 9.76",
  stroke: "#000",
  strokeWidth: 5.161,
  strokeLinecap: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 69.372,
  r: 4.8,
  fill: "var(--theme-primary, #9631ff)"
})));

      const __svgRaw = "<svg width=\"96\" height=\"96\" viewBox=\"0 0 96 96\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M10.9092 37.4356C20.2733 27.8085 33.4297 21.8184 48.0001 21.8184C62.5705 21.8184 75.7269 27.8085 85.091 37.4356\" stroke=\"black\" stroke-width=\"5.16129\" stroke-linecap=\"round\"/>\r\n<path d=\"M26.5264 55.0049C31.6301 49.0438 39.3546 45.2441 48.0001 45.2441C56.6455 45.2441 64.37 49.0438 69.4737 55.0049\" stroke=\"black\" stroke-width=\"5.16129\" stroke-linecap=\"round\"/>\r\n<circle cx=\"48.0002\" cy=\"69.3723\" r=\"4.8\" fill=\"var(--theme-primary, #9631ff)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/wifi-icon.01c0b066b2f6e86fc82fc189ea3be6a2.svg"),
        {
          React: SvgWifiIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      